import {callAPI} from '@/store/utils'; // eslint-disable-line

export default {
  namespaced: true,
  state: {
    connectedAppsList: [],
    // Owners and admins see every connection of the company; everyone else only their own.
    hasOversight: false,
    connectableAppsList: [],
  },
  mutations: {
    setConnectedAppsList(state, res) {
      state.connectedAppsList = res?.result?.data || [];
      state.hasOversight = !!res?.result?.has_oversight;
    },
    setConnectableAppsList(state, res) {
      state.connectableAppsList = res?.result?.data || [];
    },
  },
  actions: {
    async actionGetConnectedAppsList({rootState, commit}) {
      const res = await callAPI(
        'GET',
        `company/${rootState.companyId}/connectedApps`,
      );
      commit('setConnectedAppsList', res);
      return res;
    },
    async actionGetConnectableAppsList({rootState, commit}) {
      const res = await callAPI(
        'GET',
        `company/${rootState.companyId}/connectableApps`,
      );
      commit('setConnectableAppsList', res);
      return res;
    },
    // There is no create action on purpose: a connection is only ever made by the app itself,
    // through the consent screen at the end of the OAuth flow. All we can hand over is the
    // client_id the user pastes into it.
    async actionRevokeConnectedApp({rootState}, oauthGrantId) {
      return await callAPI(
        'DELETE',
        `company/${rootState.companyId}/connectedApp/${oauthGrantId}`,
      );
    },
  },
};
